module.exports = __webpack_public_path__ + "static/media/dingdong.e7afbcb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/dingdong.mp3
// module id = hb1J
// module chunks = 0